import React, { useState, useMemo } from "react";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from './Table.module.css'

const UsedQTable = ({data}) => {
  const [showEntries,setShowEntries] = useState(5)
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "id", sortable: false },
    { name: "Paper Name", field: "paper_name", sortable: false },
    { name: "Class", field: "class", sortable: false },
    { name: "Center", field: "center", sortable: false },
    { name: "Session", field: "session", sortable: false },
    { name: "Target", field: "target", sortable: false },
    { name: "Date", field: "date", sortable: false },
  ];
  const commentsData = useMemo(() => {
    let computedComments = data;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.paper_name.toLowerCase().includes(search.toLowerCase()) ||
          comment.center.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [ data,currentPage, search, sorting,ITEMS_PER_PAGE]);

  return (
    <>
            <div className="d-flex justify-content-between">
            <div>Show{" "}
                <select onChange={e => {
                    setShowEntries(e.target.value)
                    console.log(e.target.value)
                    }}>
                    <option value='5'>5</option>
                    <option value='10'>10</option>
                    <option value='20'>20</option>
                </select>
                {" "}enteries
                </div>
              <Search
                className={classes.search}
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="table-responsive">
          <table className="table table-bordered mt-3 mb-0">
            <TableHeader
            className={classes.header}
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((data,index) => (
                <tr className={classes.td} key={data.paper_id}>
                  <th scope="row">
                    {index+1}
                  </th>
                  <td>{data.paper_name}</td>
                  <td>{data.class ?? ""}</td>
                  <td>{data.center ?? ""}</td>
                  <td>{data.session}</td>
                  <td>{data.target}</td>
                  <td>{data.to_be_held_on}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          <p className="small text-start">Showing <b>{+showEntries<commentsData.length ? +showEntries : commentsData.length}</b> out of {commentsData.length} enteries</p>
          <div className="mt-4">
          <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
          </div>
    </>
  );
};

export default UsedQTable;
